import type { DecoratedOrderTask } from '@witmetrics/utils';

export const classes = {
  card: 'flex w-full mb-2 mx-2 py-3 pl-4 pr-2 rounded-xl border border-transparent hover:border-orange-2 hover:shadow-orange transition-colors duration-150',
  highlighted: 'rounded-xl border-2 border-orange-2',
  content: 'grow flex flex-col',
};

export function isHighlighted(
  { taskId }: DecoratedOrderTask,
  searchParams: URLSearchParams
) {
  if (!searchParams.get('highlightedTaskId')) return false;
  return taskId === parseInt(searchParams.get('highlightedTaskId')!);
}
